import * as React from 'react';

import type {SalesDocumentUpdateInput} from 'nutshell-graphql-types';

import {SaveableWrapper} from '../../saveable-wrapper/saveable-wrapper';

import {QuoteTextArea} from '../editable/quote-text-area';
import {NOTES} from '../helpers';
import {QuoteNoteSection} from '../read-only/quote-note-section';

type Props = {
    onSave: (arg1: SalesDocumentUpdateInput) => void;
    onCancel: () => void;
    isActive: boolean;
    id: string;
    body: string;
    onToggleActive: (arg1: string) => void;
    forceSave: boolean;
    isTemplate: boolean;
    isImmutable: boolean;
};

export function QuoteNoteWrapper(props: Props) {
    const {id, onSave} = props;
    const [body, setBody] = React.useState<string>(props.body);

    React.useEffect(() => {
        setBody(props.body);
    }, [props.body]);

    const handleSave = React.useCallback(() => {
        onSave({
            salesDocument: id,
            body,
        });
    }, [id, onSave, body]);

    React.useEffect(() => {
        if (props.forceSave) {
            handleSave();
        }
    }, [props.forceSave, handleSave]);

    const handleCancel = () => {
        setBody(props.body);
        props.onCancel();
    };

    return (
        <SaveableWrapper
            isActive={props.isActive}
            onSave={handleSave}
            onCancel={handleCancel}
            onToggleActive={props.onToggleActive}
            sectionName={NOTES}
            noPadding={true}
            isImmutable={props.isImmutable}
            showEditIcon={props.isTemplate}
        >
            {props.isActive ? (
                <QuoteTextArea
                    value={body}
                    onChange={setBody}
                    placeholder='Add any important information here for your recipient'
                    bottomPaddingForToolbar={true}
                    largerText={true}
                />
            ) : (
                <QuoteNoteSection text={body} />
            )}
        </SaveableWrapper>
    );
}
